// extracted by mini-css-extract-plugin
export default {"chip":"ScoreTag-module__chip__WiLuJ","label":"ScoreTag-module__label__scr12","score":"ScoreTag-module__score__1a6Jr"};